import { createContext, useContext } from 'react'

/** CSS scale from ResumePreviewPanelFit (1 = full A4 width). */
export const ResumePreviewFitScaleContext = createContext(1)

export function useResumePreviewFitScale(): number {
  return useContext(ResumePreviewFitScaleContext)
}
